const getAttachmentLocalSecurityInfo = () => import(
  /* webpackChunkName: "upload" */
  './getLocalSecurityInfoAsync'
).then((defaultModule) => defaultModule?.getAttachmentLocalSecurityInfo?.());

export default getAttachmentLocalSecurityInfo;